import React, { useEffect, useState } from "react";
import Header from "../../widget/index";
import Footer from "../../widget/footer/footer";
import "./static-page.scss";
import { getDataDrupal, urlDrupal } from "../../../service/constant";
import ReactHtmlParser from "react-html-parser";

export default function PrivacyPolicy() {
  const [txtPrivacy, setTxtPrivacy] = useState({
    body: "",
    title: "",
  });

  useEffect(() => {
    async function getData() {
      let result = await getDataDrupal(urlDrupal.privacypolicy);

      if (result && result.data) {
        setTxtPrivacy(result.data?.[0]);
      }
    }
    getData();
  }, []);

  return (
    <div>
      <Header />
      <section className="terms-privacy">
        <div className="container mx-auto">
          {/* {txtPrivacy && ReactHtmlParser(txtPrivacy && txtPrivacy.body)} */}
          <section className="terms-privacy">
          <div className="container mx-auto">
              <p>
                  <span>
                      <span>
                          <span>
                              <span>
                                  <strong>
                                      <span>
                                          <span>
                                              <span>Privacy Policy</span>
                                          </span>
                                      </span>
                                  </strong>
                              </span>
                          </span>
                      </span>
                  </span>
              </p>
              <p>
                  <span>
                      <span>
                          <span>
                              <span>
                                  <span>
                                      <span>This Website collects some Personal Data from its Users.</span>
                                  </span>
                              </span>
                          </span>
                      </span>
                  </span>
              </p>
              <p>
                  <span>
                      <span>
                          <span>
                              <span>
                                  <span>
                                      <span>This document contains&nbsp;</span>
                                  </span>
                                  <span>
                                      <a href="https://www.devinsider.com/policy.html#information_californian">
                                          <span>
                                              <span>a section dedicated to Californian consumers and their privacy rights&nbsp;</span>
                                          </span>
                                      </a>
                                  </span>
                                  <span>
                                      <span>.</span>
                                  </span>
                              </span>
                          </span>
                      </span>
                  </span>
              </p>
              <p>
                  <span>
                      <span>
                          <span>
                              <span>
                                  <span>
                                      <span>This document can be printed for reference by using the print command in the settings of any browser.</span>
                                  </span>
                              </span>
                          </span>
                      </span>
                  </span>
              </p>
              <p>
                  <span>
                      <span>
                          <span>
                              <span>
                                  <span>
                                      <span>As a visitor or member of our Platform or agreeing to these Terms and Conditions, the collection, use and sharing of your personal data is subject to our Privacy Policy. This Terms and Conditions refers to our Privacy Policy which also applies to your use of the Platform and which sets out the terms on which we process any personal data we collect from you, or that you provide to us.</span>
                                  </span>
                              </span>
                          </span>
                      </span>
                  </span>
              </p>
              <p>
                  <span>
                      <span>
                          <span>
                              <span>
                                  <span>
                                      <span>You shall use any personal data downloaded, accessed or otherwise received though the Platform solely in connection with your use of the Platform in accordance with this Terms and Conditions. You represent, warrant, and covenant that you shall process any and all personal data for this limited and specified purpose, consistent with any consent provided by the individual to whom personal data relates, and that you shall process all Personal Data in compliance with the EU and U.S. legislation.</span>
                                  </span>
                              </span>
                          </span>
                      </span>
                  </span>
              </p>
              <p>
                  <span>
                      <span>
                          <span>
                              <span>
                                  <span>
                                      <span>You shall not, and shall not allow any third party to, present the data so that it appears to be made available by any third party;</span>
                                  </span>
                              </span>
                          </span>
                      </span>
                  </span>
              </p>
              <p>
                  <span>
                      <span>
                          <span>
                              <span>
                                  <span>
                                      <span>You shall comply with any codes of conduct, policies or other notices we provide you or publish in connection with the Platform, and you shall promptly notify Devinsider if you learn of a security breach related to the Platform.</span>
                                  </span>
                              </span>
                          </span>
                      </span>
                  </span>
              </p>
              <p>
                  <span>
                      <span>
                          <span>
                              <span>
                                  <span>
                                      <span>Devinsider reserves the right to use your name and logo as a reference for marketing or promotional purposes only on Devinsider Platform and in other communication with existing or potential customers.</span>
                                  </span>
                              </span>
                          </span>
                      </span>
                  </span>
              </p>
              <p>
                  <span>
                      <span>
                          <span>
                              <span>
                                  <span>
                                      <span>You and Devinsider agree that we may access, store, process and use any information and personal data that you provide in accordance with our terms of the Privacy Policy and your choices (including settings).</span>
                                  </span>
                              </span>
                          </span>
                      </span>
                  </span>
              </p>
              <p>&nbsp;</p>
              <p>
                  <span>
                      <span>
                          <span>
                              <span>
                                  <strong>
                                      <span>
                                          <span>
                                              <span>Owner and Data Controller</span>
                                          </span>
                                      </span>
                                  </strong>
                              </span>
                          </span>
                      </span>
                  </span>
              </p>
              <p><br />
                  <span>
                      <span>
                          <span>
                              <span>
                                  <span>
                                      <span>Devinsider</span>
                                  </span>
                              </span>
                          </span>
                      </span>
                  </span>
              </p>
              <p>
                  <span>
                      <span>
                          <span>
                              <span>
                                  <span>
                                      <span>23-25 rue Jean-Jacques Rousseau, Paris 75001, France.</span>
                                  </span>
                              </span>
                          </span>
                      </span>
                  </span>
              </p>
              <p>
                  <span>
                      <span>
                          <span>
                              <span>
                                  <strong>
                                      <span>
                                          <span>Owner contact email:</span>
                                      </span>
                                  </strong>
                                  <span>
                                      <span>&nbsp;contact@devinsider.com</span>
                                  </span>
                              </span>
                          </span>
                      </span>
                  </span>
              </p>
              <p>
                  <span>
                      <span>
                          <span>
                              <span>
                                  <strong>
                                      <span>
                                          <span>
                                              <span>Types of Data collected</span>
                                          </span>
                                      </span>
                                  </strong>
                              </span>
                          </span>
                      </span>
                  </span>
              </p>
              <p>
                  <span>
                      <span>
                          <span>
                              <span>
                                  <span>
                                      <span>Among the types of Personal Data that this Website collects, by itself or through third parties, there are: Usage Data; Tracker; first name; last name; country; email address.</span>
                                  </span>
                              </span>
                          </span>
                      </span>
                  </span>
              </p>
              <p>
                  <span>
                      <span>
                          <span>
                              <span>
                                  <span>
                                      <span>
                                          Complete details on each type of Personal Data collected are provided in the dedicated sections of this privacy policy or by specific explanation texts displayed prior to the Data collection.<br />
                                          Personal Data may be freely provided by the User, or, in case of Usage Data, collected automatically when using this Website.<br />
                                          Unless specified otherwise, all Data requested by this Website is mandatory and failure to provide this Data may make it impossible for this Website to provide its services. In cases where this Website specifically states that some Data is not mandatory, Users are free not to communicate this Data without consequences to the availability or the functioning of the Service.<br />
                                          Users who are uncertain about which Personal Data is mandatory are welcome to contact the Owner.<br />
                                          Any use of Cookies – or of other tracking tools – by this Website or by the owners of third-party services used by this Website serves the purpose of providing the Service required by the User, in addition to any other purposes described in the present document and in the Cookie Policy, if available.
                                      </span>
                                  </span>
                              </span>
                          </span>
                      </span>
                  </span>
              </p>
              <p>
                  <span>
                      <span>
                          <span>
                              <span>
                                  <span>
                                      <span>Users are responsible for any third-party Personal Data obtained, published or shared through this Website and confirm that they have the third party's consent to provide the Data to the Owner.</span>
                                  </span>
                              </span>
                          </span>
                      </span>
                  </span>
              </p>
              <p>
                  <span>
                      <span>
                          <span>
                              <span>
                                  <strong>
                                      <span>
                                          <span>
                                              <span>Mode and place of processing the Data</span>
                                          </span>
                                      </span>
                                  </strong>
                              </span>
                          </span>
                      </span>
                  </span>
              </p>
              <p>
                  <span>
                      <span>
                          <span>
                              <span>
                                  <span>
                                      <span>
                                          <span>Methods of processing</span>
                                      </span>
                                  </span>
                              </span>
                          </span>
                      </span>
                  </span>
              </p>
              <p>
                  <span>
                      <span>
                          <span>
                              <span>
                                  <span>
                                      <span>The Owner takes appropriate security measures to prevent unauthorized access, disclosure, modification, or unauthorized destruction of the Data.</span>
                                  </span>
                              </span>
                          </span>
                      </span>
                  </span>
              </p>
              <p>
                  <span>
                      <span>
                          <span>
                              <span>
                                  <span>
                                      <span>The Owner will not share the Data with affiliates and this privacy policy is applicable to the Devinsider brand only. Affiliates include parent company and any subsidiaries, joint venture partners, or other companies that are under common control with Devinsider.</span>
                                  </span>
                              </span>
                          </span>
                      </span>
                  </span>
              </p>
              <p>
                  <span>
                      <span>
                          <span>
                              <span>
                                  <span>
                                      <span>The Data processing is carried out using computers and/or IT enabled tools, following organizational procedures and modes strictly related to the purposes indicated. In addition to the Owner, in some cases, the Data may be accessible to certain types of persons in charge, involved with the operation of this Website (administration, sales, marketing, legal, system administration) or external parties (such as third-party technical service providers, mail carriers, hosting providers, IT companies, communications agencies) appointed, if necessary, as Data Processors by the Owner. The updated list of these parties may be requested from the Owner at any time.</span>
                                  </span>
                              </span>
                          </span>
                      </span>
                  </span>
              </p>
              <p>
                  <span>
                      <span>
                          <span>
                              <span>
                                  <span>
                                      <span>
                                          <span>Legal basis of processing</span>
                                      </span>
                                  </span>
                              </span>
                          </span>
                      </span>
                  </span>
              </p>
              <p>
                  <span>
                      <span>
                          <span>
                              <span>
                                  <span>
                                      <span>The Owner may process Personal Data relating to Users if one of the following applies:</span>
                                  </span>
                              </span>
                          </span>
                      </span>
                  </span>
              </p>
              <ul>
                  <li>
                      <span>
                          <span>
                              <span>
                                  <span>
                                      <span>
                                          <span>
                                              <span>Users have given their consent for one or more specific purposes. Note: Under some legislations the Owner may be allowed to process Personal Data until the User objects to such processing (“opt-out”), without having to rely on consent or any other of the following legal bases. This, however, does not apply, whenever the processing of Personal Data is subject to European data protection law;</span>
                                          </span>
                                      </span>
                                  </span>
                              </span>
                          </span>
                      </span>
                  </li>
                  <li>
                      <span>
                          <span>
                              <span>
                                  <span>
                                      <span>
                                          <span>
                                              <span>provision of Data is necessary for the performance of an agreement with the User and/or for any pre-contractual obligations thereof;</span>
                                          </span>
                                      </span>
                                  </span>
                              </span>
                          </span>
                      </span>
                  </li>
                  <li>
                      <span>
                          <span>
                              <span>
                                  <span>
                                      <span>
                                          <span>
                                              <span>processing is necessary for compliance with a legal obligation to which the Owner is subject;</span>
                                          </span>
                                      </span>
                                  </span>
                              </span>
                          </span>
                      </span>
                  </li>
                  <li>
                      <span>
                          <span>
                              <span>
                                  <span>
                                      <span>
                                          <span>
                                              <span>processing is related to a task that is carried out in the public interest or in the exercise of official authority vested in the Owner;</span>
                                          </span>
                                      </span>
                                  </span>
                              </span>
                          </span>
                      </span>
                  </li>
                  <li>
                      <span>
                          <span>
                              <span>
                                  <span>
                                      <span>
                                          <span>
                                              <span>processing is necessary for the purposes of the legitimate interests pursued by the Owner or by a third party.</span>
                                          </span>
                                      </span>
                                  </span>
                              </span>
                          </span>
                      </span>
                  </li>
              </ul>
              <p>
                  <span>
                      <span>
                          <span>
                              <span>
                                  <span>
                                      <span>In any case, the Owner will gladly help to clarify the specific legal basis that applies to the processing, and in particular whether the provision of Personal Data is a statutory or contractual requirement, or a requirement necessary to enter into a contract.</span>
                                  </span>
                              </span>
                          </span>
                      </span>
                  </span>
              </p>
              <p>
                  <span>
                      <span>
                          <span>
                              <span>
                                  <span>
                                      <span>
                                          <span>Place</span>
                                      </span>
                                  </span>
                              </span>
                          </span>
                      </span>
                  </span>
              </p>
              <p>
                  <span>
                      <span>
                          <span>
                              <span>
                                  <span>
                                      <span>
                                          The Data is processed at the Owner's operating offices and in any other places where the parties involved in the processing are located.<br /><br />
                                          Depending on the User's location, data transfers may involve transferring the User's Data to a country other than their own. To find out more about the place of processing of such transferred Data, Users can check the section containing details about the processing of Personal Data.
                                      </span>
                                  </span>
                              </span>
                          </span>
                      </span>
                  </span>
              </p>
              <p>
                  <span>
                      <span>
                          <span>
                              <span>
                                  <span>
                                      <span>
                                          Users are also entitled to learn about the legal basis of Data transfers to a country outside the European Union or to any international organization governed by public international law or set up by two or more countries, such as the UN, and about the security measures taken by the Owner to safeguard their Data.<br /><br />
                                          If any such transfer takes place, Users can find out more by checking the relevant sections of this document or inquire with the Owner using the information provided in the contact section.
                                      </span>
                                  </span>
                              </span>
                          </span>
                      </span>
                  </span>
              </p>
              <p>
                  <span>
                      <span>
                          <span>
                              <span>
                                  <span>
                                      <span>
                                          <span>Retention time</span>
                                      </span>
                                  </span>
                              </span>
                          </span>
                      </span>
                  </span>
              </p>
              <p>
                  <span>
                      <span>
                          <span>
                              <span>
                                  <span>
                                      <span>Personal Data shall be processed and stored for as long as required by the purpose they have been collected for.</span>
                                  </span>
                              </span>
                          </span>
                      </span>
                  </span>
              </p>
              <p>
                  <span>
                      <span>
                          <span>
                              <span>
                                  <span>
                                      <span>Therefore:</span>
                                  </span>
                              </span>
                          </span>
                      </span>
                  </span>
              </p>
              <ul>
                  <li>
                      <span>
                          <span>
                              <span>
                                  <span>
                                      <span>
                                          <span>
                                              <span>Personal Data collected for purposes related to the performance of a contract between the Owner and the User shall be retained until such contract has been fully performed.</span>
                                          </span>
                                      </span>
                                  </span>
                              </span>
                          </span>
                      </span>
                  </li>
                  <li>
                      <span>
                          <span>
                              <span>
                                  <span>
                                      <span>
                                          <span>
                                              <span>Personal Data collected for the purposes of the Owner’s legitimate interests shall be retained as long as needed to fulfill such purposes. Users may find specific information regarding the legitimate interests pursued by the Owner within the relevant sections of this document or by contacting the Owner.</span>
                                          </span>
                                      </span>
                                  </span>
                              </span>
                          </span>
                      </span>
                  </li>
              </ul>
              <p>
                  <span>
                      <span>
                          <span>
                              <span>
                                  <span>
                                      <span>
                                          The Owner may be allowed to retain Personal Data for a longer period whenever the User has given consent to such processing, as long as such consent is not withdrawn. Furthermore, the Owner may be obliged to retain Personal Data for a longer period whenever required to do so for the performance of a legal obligation or upon order of an authority.<br /><br />
                                          Once the retention period expires, Personal Data shall be deleted. Therefore, the right to access, the right to erasure, the right to rectification and the right to data portability cannot be enforced after expiration of the retention period.
                                      </span>
                                  </span>
                              </span>
                          </span>
                      </span>
                  </span>
              </p>
              <p>
                  <span>
                      <span>
                          <span>
                              <span>
                                  <strong>
                                      <span>
                                          <span>
                                              <span>The purposes of processing</span>
                                          </span>
                                      </span>
                                  </strong>
                              </span>
                          </span>
                      </span>
                  </span>
              </p>
              <p>
                  <span>
                      <span>
                          <span>
                              <span>
                                  <span>
                                      <span>The Data concerning the User is collected to allow the Owner to provide its Service, comply with its legal obligations, respond to enforcement requests, protect its rights and interests (or those of its Users or third parties), detect any malicious or fraudulent activity, as well as the following: Displaying content from external platforms, Analytics, SPAM protection and Contacting the User.</span>
                                  </span>
                              </span>
                          </span>
                      </span>
                  </span>
              </p>
              <p>
                  <span>
                      <span>
                          <span>
                              <span>
                                  <span>
                                      <span>For specific information about the Personal Data used for each purpose, the User may refer to the section “Detailed information on the processing of Personal Data”.</span>
                                  </span>
                              </span>
                          </span>
                      </span>
                  </span>
              </p>
              <p>
                  <span>
                      <span>
                          <span>
                              <span>
                                  <strong>
                                      <span>
                                          <span>
                                              <span>Detailed information on the processing of Personal Data</span>
                                          </span>
                                      </span>
                                  </strong>
                              </span>
                          </span>
                      </span>
                  </span>
              </p>
              <p>
                  <span>
                      <span>
                          <span>
                              <span>
                                  <span>
                                      <span>Personal Data is collected for the following purposes and using the following services:</span>
                                  </span>
                              </span>
                          </span>
                      </span>
                  </span>
              </p>
              <ul>
                  <li>
                      <span>
                          <span>
                              <span>
                                  <span>
                                      <span>
                                          <span>
                                              <span>
                                                  <span>Analytics</span>
                                              </span>
                                          </span>
                                      </span>
                                  </span>
                              </span>
                          </span>
                      </span>
                  </li>
              </ul>
              <p>
                  <span>
                      <span>
                          <span>
                              <span>
                                  <span>
                                      <span>The services contained in this section enable the Owner to monitor and analyze web traffic and can be used to keep track of User behavior.</span>
                                  </span>
                              </span>
                          </span>
                      </span>
                  </span>
              </p>
              <ul>
                  <li>
                      <span>
                          <span>
                              <span>
                                  <span>
                                      <span>
                                          <span>
                                              <span>
                                                  <span>Contacting the User</span>
                                              </span>
                                          </span>
                                      </span>
                                  </span>
                              </span>
                          </span>
                      </span>
                  </li>
              </ul>
              <p>
                  <span>
                      <span>
                          <span>
                              <span>
                                  <span>
                                      <span>Contact form (this Website)</span>
                                  </span>
                              </span>
                          </span>
                      </span>
                  </span>
              </p>
              <p>
                  <span>
                      <span>
                          <span>
                              <span>
                                  <span>
                                      <span>By filling in the contact form with their Data, the User authorizes this Website to use these details to reply to requests for information, quotes or any other kind of request as indicated by the form’s header.</span>
                                  </span>
                              </span>
                          </span>
                      </span>
                  </span>
              </p>
              <p>
                  <span>
                      <span>
                          <span>
                              <span>
                                  <span>
                                      <span>Personal Data processed: country; email address; first name; last name.</span>
                                  </span>
                              </span>
                          </span>
                      </span>
                  </span>
              </p>
              <p>
                  <span>
                      <span>
                          <span>
                              <span>
                                  <span>
                                      <span>Category of personal information collected according to CCPA: identifiers.</span>
                                  </span>
                              </span>
                          </span>
                      </span>
                  </span>
              </p>
              <ul>
                  <li>
                      <span>
                          <span>
                              <span>
                                  <span>
                                      <span>
                                          <span>
                                              <span>
                                                  <span>Displaying content from external platforms</span>
                                              </span>
                                          </span>
                                      </span>
                                  </span>
                              </span>
                          </span>
                      </span>
                  </li>
              </ul>
              <p>
                  <span>
                      <span>
                          <span>
                              <span>
                                  <span>
                                      <span>
                                          This type of service allows you to view content hosted on external platforms directly from the pages of this Website and interact with them.<br />
                                          This type of service might still collect web traffic data for the pages where the service is installed, even when Users do not use it.
                                      </span>
                                  </span>
                              </span>
                          </span>
                      </span>
                  </span>
              </p>
              <p>
                  <span>
                      <span>
                          <span>
                              <span>
                                  <span>
                                      <span>
                                          <span>Google Fonts</span>
                                      </span>
                                  </span>
                              </span>
                          </span>
                      </span>
                  </span>
              </p>
              <p>
                  <span>
                      <span>
                          <span>
                              <span>
                                  <span>
                                      <span>Google Fonts is a typeface visualization service provided by Google LLC or by Google Ireland Limited, depending on the location this Website is accessed from, that allows this Website to incorporate content of this kind on its pages.</span>
                                  </span>
                              </span>
                          </span>
                      </span>
                  </span>
              </p>
              <p>
                  <span>
                      <span>
                          <span>
                              <span>
                                  <span>
                                      <span>Personal Data processed: Usage Data; various types of Data as specified in the privacy policy of the service.</span>
                                  </span>
                              </span>
                          </span>
                      </span>
                  </span>
              </p>
              <p>
                  <span>
                      <span>
                          <span>
                              <span>
                                  <span>
                                      <span>Place of processing: United States –&nbsp;</span>
                                  </span>
                                  <span>
                                      <a href="https://policies.google.com/privacy">
                                          <span>
                                              <span>Privacy Policy&nbsp;</span>
                                          </span>
                                      </a>
                                  </span>
                                  <span>
                                      <span>; Ireland –&nbsp;</span>
                                  </span>
                                  <span>
                                      <a href="https://policies.google.com/privacy">
                                          <span>
                                              <span>Privacy Policy&nbsp;</span>
                                          </span>
                                      </a>
                                  </span>
                                  <span>
                                      <span>.</span>
                                  </span>
                              </span>
                          </span>
                      </span>
                  </span>
              </p>
              <p>
                  <span>
                      <span>
                          <span>
                              <span>
                                  <span>
                                      <span>Category of personal information collected according to CCPA: internet information.</span>
                                  </span>
                              </span>
                          </span>
                      </span>
                  </span>
              </p>
              <p>
                  <span>
                      <span>
                          <span>
                              <span>
                                  <span>
                                      <span>This processing constitutes a sale based on the definition under the CCPA. In addition to the information in this clause, the User can find information regarding how to opt out of the sale in the section detailing the rights of Californian consumers.</span>
                                  </span>
                              </span>
                          </span>
                      </span>
                  </span>
              </p>
              <ul>
                  <li>
                      <span>
                          <span>
                              <span>
                                  <span>
                                      <span>
                                          <span>
                                              <span>
                                                  <span>SPAM protection</span>
                                              </span>
                                          </span>
                                      </span>
                                  </span>
                              </span>
                          </span>
                      </span>
                  </li>
              </ul>
              <p>
                  <span>
                      <span>
                          <span>
                              <span>
                                  <span>
                                      <span>This type of service analyzes the traffic of this Website, potentially containing Users' Personal Data, with the purpose of filtering it from parts of traffic, messages and content that are recognized as SPAM.</span>
                                  </span>
                              </span>
                          </span>
                      </span>
                  </span>
              </p>
              <p>
                  <span>
                      <span>
                          <span>
                              <span>
                                  <span>
                                      <span>
                                          <span>Google reCAPTCHA</span>
                                      </span>
                                  </span>
                              </span>
                          </span>
                      </span>
                  </span>
              </p>
              <p>
                  <span>
                      <span>
                          <span>
                              <span>
                                  <span>
                                      <span>
                                          Google reCAPTCHA is a SPAM protection service provided by Google LLC or by Google Ireland Limited, depending on the location this Website is accessed from.<br />
                                          The use of reCAPTCHA is subject to the Google&nbsp;
                                      </span>
                                  </span>
                                  <span>
                                      <a href="https://www.google.com/policies/privacy/">
                                          <span>
                                              <span>privacy policy&nbsp;</span>
                                          </span>
                                      </a>
                                  </span>
                                  <span>
                                      <span>and&nbsp;</span>
                                  </span>
                                  <span>
                                      <a href="https://www.google.com/intl/en/policies/terms/">
                                          <span>
                                              <span>terms of use .</span>
                                          </span>
                                      </a>
                                  </span>
                              </span>
                          </span>
                      </span>
                  </span>
              </p>
              <p>
                  <span>
                      <span>
                          <span>
                              <span>
                                  <span>
                                      <span>Personal Data processed: Tracker; Usage Data.</span>
                                  </span>
                              </span>
                          </span>
                      </span>
                  </span>
              </p>
              <p>
                  <span>
                      <span>
                          <span>
                              <span>
                                  <span>
                                      <span>Place of processing: United States –&nbsp;</span>
                                  </span>
                                  <span>
                                      <a href="https://policies.google.com/privacy">
                                          <span>
                                              <span>Privacy Policy&nbsp;</span>
                                          </span>
                                      </a>
                                  </span>
                                  <span>
                                      <span>; Ireland –&nbsp;</span>
                                  </span>
                                  <span>
                                      <a href="https://policies.google.com/privacy">
                                          <span>
                                              <span>Privacy Policy.</span>
                                          </span>
                                      </a>
                                  </span>
                              </span>
                          </span>
                      </span>
                  </span>
              </p>
              <p>
                  <span>
                      <span>
                          <span>
                              <span>
                                  <span>
                                      <span>Category of personal information collected according to CCPA: internet information.</span>
                                  </span>
                              </span>
                          </span>
                      </span>
                  </span>
              </p>
              <p>&nbsp;</p>
              <p>
                  <span>
                      <span>
                          <span>
                              <span>
                                  <strong>
                                      <span>
                                          <span>
                                              <span>The rights of Users</span>
                                          </span>
                                      </span>
                                  </strong>
                              </span>
                          </span>
                      </span>
                  </span>
              </p>
              <p>
                  <span>
                      <span>
                          <span>
                              <span>
                                  <span>
                                      <span>Users may exercise certain rights regarding their Data processed by the Owner.</span>
                                  </span>
                              </span>
                          </span>
                      </span>
                  </span>
              </p>
              <p>
                  <span>
                      <span>
                          <span>
                              <span>
                                  <span>
                                      <span>In particular, Users have the right to do the following:</span>
                                  </span>
                              </span>
                          </span>
                      </span>
                  </span>
              </p>
              <ul>
                  <li>
                      <span>
                          <span>
                              <span>
                                  <span>
                                      <span>
                                          <span>
                                              <strong>
                                                  <span>Withdraw their consent at any time.</span>
                                              </strong>
                                              <span>&nbsp;Users have the right to withdraw consent where they have previously given their consent to the processing of their Personal Data.</span>
                                          </span>
                                      </span>
                                  </span>
                              </span>
                          </span>
                      </span>
                  </li>
                  <li>
                      <span>
                          <span>
                              <span>
                                  <span>
                                      <span>
                                          <span>
                                              <strong>
                                                  <span>Object to processing of their Data.</span>
                                              </strong>
                                              <span>&nbsp;Users have the right to object to the processing of their Data if the processing is carried out on a legal basis other than consent. Further details are provided in the dedicated section below.</span>
                                          </span>
                                      </span>
                                  </span>
                              </span>
                          </span>
                      </span>
                  </li>
                  <li>
                      <span>
                          <span>
                              <span>
                                  <span>
                                      <span>
                                          <span>
                                              <strong>
                                                  <span>Access their Data.</span>
                                              </strong>
                                              <span>&nbsp;Users have the right to learn if Data is being processed by the Owner, obtain disclosure regarding certain aspects of the processing and obtain a copy of the Data undergoing processing.</span>
                                          </span>
                                      </span>
                                  </span>
                              </span>
                          </span>
                      </span>
                  </li>
                  <li>
                      <span>
                          <span>
                              <span>
                                  <span>
                                      <span>
                                          <span>
                                              <strong>
                                                  <span>Verify and seek rectification.</span>
                                              </strong>
                                              <span>&nbsp;Users have the right to verify the accuracy of their Data and ask for it to be updated or corrected.</span>
                                          </span>
                                      </span>
                                  </span>
                              </span>
                          </span>
                      </span>
                  </li>
                  <li>
                      <span>
                          <span>
                              <span>
                                  <span>
                                      <span>
                                          <span>
                                              <strong>
                                                  <span>Restrict the processing of their Data.</span>
                                              </strong>
                                              <span>&nbsp;Users have the right, under certain circumstances, to restrict the processing of their Data. In this case, the Owner will not process their Data for any purpose other than storing it.</span>
                                          </span>
                                      </span>
                                  </span>
                              </span>
                          </span>
                      </span>
                  </li>
                  <li>
                      <span>
                          <span>
                              <span>
                                  <span>
                                      <span>
                                          <span>
                                              <strong>
                                                  <span>Have their Personal Data deleted or otherwise removed.</span>
                                              </strong>
                                              <span>&nbsp;Users have the right, under certain circumstances, to obtain the erasure of their Data from the Owner.</span>
                                          </span>
                                      </span>
                                  </span>
                              </span>
                          </span>
                      </span>
                  </li>
                  <li>
                      <span>
                          <span>
                              <span>
                                  <span>
                                      <span>
                                          <span>
                                              <strong>
                                                  <span>Receive their Data and have it transferred to another controller.&nbsp;</span>
                                              </strong>
                                              <span>Users have the right to receive their Data in a structured, commonly used and machine readable format and, if technically feasible, to have it transmitted to another controller without any hindrance. This provision is applicable provided that the Data is processed by automated means and that the processing is based on the User's consent, on a contract which the User is part of or on pre-contractual obligations thereof.</span>
                                          </span>
                                      </span>
                                  </span>
                              </span>
                          </span>
                      </span>
                  </li>
                  <li>
                      <span>
                          <span>
                              <span>
                                  <span>
                                      <span>
                                          <span>
                                              <strong>
                                                  <span>Lodge a complaint.</span>
                                              </strong>
                                              <span>&nbsp;Users have the right to bring a claim before their competent data protection authority.</span>
                                          </span>
                                      </span>
                                  </span>
                              </span>
                          </span>
                      </span>
                  </li>
              </ul>
              <p>
                  <span>
                      <span>
                          <span>
                              <span>
                                  <span>
                                      <span>
                                          <span>Details about the right to object to processing</span>
                                      </span>
                                  </span>
                              </span>
                          </span>
                      </span>
                  </span>
              </p>
              <p>
                  <span>
                      <span>
                          <span>
                              <span>
                                  <span>
                                      <span>Where Personal Data is processed for a public interest, in the exercise of an official authority vested in the Owner or for the purposes of the legitimate interests pursued by the Owner, Users may object to such processing by providing a ground related to their particular situation to justify the objection.</span>
                                  </span>
                              </span>
                          </span>
                      </span>
                  </span>
              </p>
              <p>
                  <span>
                      <span>
                          <span>
                              <span>
                                  <span>
                                      <span>Users must know that, however, should their Personal Data be processed for direct marketing purposes, they can object to that processing at any time without providing any justification. To learn, whether the Owner is processing Personal Data for direct marketing purposes, Users may refer to the relevant sections of this document.</span>
                                  </span>
                              </span>
                          </span>
                      </span>
                  </span>
              </p>
              <p>
                  <span>
                      <span>
                          <span>
                              <span>
                                  <span>
                                      <span>
                                          <span>How to exercise these rights</span>
                                      </span>
                                  </span>
                              </span>
                          </span>
                      </span>
                  </span>
              </p>
              <p>
                  <span>
                      <span>
                          <span>
                              <span>
                                  <span>
                                      <span>Any requests to exercise User rights can be directed to the Owner through the contact details provided in this document. These requests can be exercised free of charge and will be addressed by the Owner as early as possible and always within one month.</span>
                                  </span>
                              </span>
                          </span>
                      </span>
                  </span>
              </p>
              <p>
                  <span>
                      <span>
                          <span>
                              <span>
                                  <strong>
                                      <span>
                                          <span>
                                              <span>Additional information about Data collection and processing</span>
                                          </span>
                                      </span>
                                  </strong>
                              </span>
                          </span>
                      </span>
                  </span>
              </p>
              <p>
                  <span>
                      <span>
                          <span>
                              <span>
                                  <span>
                                      <span>
                                          <span>Legal action</span>
                                      </span>
                                  </span>
                              </span>
                          </span>
                      </span>
                  </span>
              </p>
              <p>
                  <span>
                      <span>
                          <span>
                              <span>
                                  <span>
                                      <span>
                                          The User's Personal Data may be used for legal purposes by the Owner in Court or in the stages leading to possible legal action arising from improper use of this Website or the related Services.<br />
                                          The User declares to be aware that the Owner may be required to reveal personal data upon request of public authorities.
                                      </span>
                                  </span>
                              </span>
                          </span>
                      </span>
                  </span>
              </p>
              <p>
                  <span>
                      <span>
                          <span>
                              <span>
                                  <span>
                                      <span>
                                          <span>Additional information about User's Personal Data</span>
                                      </span>
                                  </span>
                              </span>
                          </span>
                      </span>
                  </span>
              </p>
              <p>
                  <span>
                      <span>
                          <span>
                              <span>
                                  <span>
                                      <span>In addition to the information contained in this privacy policy, this Website may provide the User with additional and contextual information concerning particular Services or the collection and processing of Personal Data upon request.</span>
                                  </span>
                              </span>
                          </span>
                      </span>
                  </span>
              </p>
              <p>
                  <span>
                      <span>
                          <span>
                              <span>
                                  <span>
                                      <span>
                                          <span>System logs and maintenance</span>
                                      </span>
                                  </span>
                              </span>
                          </span>
                      </span>
                  </span>
              </p>
              <p>
                  <span>
                      <span>
                          <span>
                              <span>
                                  <span>
                                      <span>For operation and maintenance purposes, this Website and any third-party services may collect files that record interaction with this Website (System logs) use other Personal Data (such as the IP Address) for this purpose.</span>
                                  </span>
                              </span>
                          </span>
                      </span>
                  </span>
              </p>
              <p>
                  <span>
                      <span>
                          <span>
                              <span>
                                  <span>
                                      <span>
                                          <span>Information not contained in this policy</span>
                                      </span>
                                  </span>
                              </span>
                          </span>
                      </span>
                  </span>
              </p>
              <p>
                  <span>
                      <span>
                          <span>
                              <span>
                                  <span>
                                      <span>More details concerning the collection or processing of Personal Data may be requested from the Owner at any time. Please see the contact information at the beginning of this document.</span>
                                  </span>
                              </span>
                          </span>
                      </span>
                  </span>
              </p>
              <p>
                  <span>
                      <span>
                          <span>
                              <span>
                                  <span>
                                      <span>
                                          <span>How “Do Not Track” requests are handled</span>
                                      </span>
                                  </span>
                              </span>
                          </span>
                      </span>
                  </span>
              </p>
              <p>
                  <span>
                      <span>
                          <span>
                              <span>
                                  <span>
                                      <span>
                                          This Website does not support “Do Not Track” requests.<br />
                                          To determine whether any of the third-party services it uses honor the “Do Not Track” requests, please read their privacy policies.
                                      </span>
                                  </span>
                              </span>
                          </span>
                      </span>
                  </span>
              </p>
              <p>
                  <span>
                      <span>
                          <span>
                              <span>
                                  <span>
                                      <span>
                                          <span>Changes to this privacy policy</span>
                                      </span>
                                  </span>
                              </span>
                          </span>
                      </span>
                  </span>
              </p>
              <p>
                  <span>
                      <span>
                          <span>
                              <span>
                                  <span>
                                      <span>
                                          The Owner reserves the right to make changes to this privacy policy at any time by notifying its Users on this page and possibly within this Website and/or - as far as technically and legally feasible - sending a notice to Users via any contact information available to the Owner. It is strongly recommended to check this page often, referring to the date of the last modification listed at the bottom.<br /><br />
                                          Should the changes affect processing activities performed on the basis of the User’s consent, the Owner shall collect new consent from the User, where required.
                                      </span>
                                  </span>
                              </span>
                          </span>
                      </span>
                  </span>
              </p>
              <p>
                  <span>
                      <span>
                          <span>
                              <span>
                                  <strong>
                                      <span>
                                          <span>
                                              <span>Information for Californian consumers</span>
                                          </span>
                                      </span>
                                  </strong>
                              </span>
                          </span>
                      </span>
                  </span>
              </p>
              <p>
                  <span>
                      <span>
                          <span>
                              <span>
                                  <span>
                                      <span>This part of the document integrates with and supplements the information contained in the rest of the privacy policy and is provided by the business running this Website and, if the case may be, its parent, subsidiaries and affiliates (for the purposes of this section referred to collectively as “we”, “us”, “our”).</span>
                                  </span>
                              </span>
                          </span>
                      </span>
                  </span>
              </p>
              <p>
                  <span>
                      <span>
                          <span>
                              <span>
                                  <span>
                                      <span>The provisions contained in this section apply to all Users who are consumers residing in the state of California, United States of America, according to "The California Consumer Privacy Act of 2018" (Users are referred to below, simply as “you”, “your”, “yours”), and, for such consumers, these provisions supersede any other possibly divergent or conflicting provisions contained in the privacy policy.</span>
                                  </span>
                              </span>
                          </span>
                      </span>
                  </span>
              </p>
              <p>
                  <span>
                      <span>
                          <span>
                              <span>
                                  <span>
                                      <span>This part of the document uses the term “personal information“ as it is defined in The California Consumer Privacy Act (CCPA).</span>
                                  </span>
                              </span>
                          </span>
                      </span>
                  </span>
              </p>
              <p>
                  <span>
                      <span>
                          <span>
                              <span>
                                  <span>
                                      <span>
                                          <span>Categories of personal information collected, disclosed or sold</span>
                                      </span>
                                  </span>
                              </span>
                          </span>
                      </span>
                  </span>
              </p>
              <p>
                  <span>
                      <span>
                          <span>
                              <span>
                                  <span>
                                      <span>
                                          In this section we summarize the categories of personal information that we've collected, disclosed or sold and the purposes thereof.&nbsp;
                                          <strong>You can read about these activities in detail in the section titled “Detailed information on the processing of Personal Data” within this document.</strong>
                                      </span>
                                  </span>
                              </span>
                          </span>
                      </span>
                  </span>
              </p>
              <p>
                  <span>
                      <span>
                          <span>
                              <span>
                                  <span>
                                      <span>
                                          <span>Information we collect: the categories of personal information we collect</span>
                                      </span>
                                  </span>
                              </span>
                          </span>
                      </span>
                  </span>
              </p>
              <p>
                  <span>
                      <span>
                          <span>
                              <span>
                                  <span>
                                      <span>We have collected the following categories of personal information about you: identifiers and internet information.</span>
                                  </span>
                              </span>
                          </span>
                      </span>
                  </span>
              </p>
              <p>
                  <span>
                      <span>
                          <span>
                              <span>
                                  <span>
                                      <span>We will not collect additional categories of personal information without notifying you.</span>
                                  </span>
                              </span>
                          </span>
                      </span>
                  </span>
              </p>
              <p>
                  <span>
                      <span>
                          <span>
                              <span>
                                  <span>
                                      <span>
                                          <span>How we collect information: what are the sources of the personal information we collect?</span>
                                      </span>
                                  </span>
                              </span>
                          </span>
                      </span>
                  </span>
              </p>
              <p>
                  <span>
                      <span>
                          <span>
                              <span>
                                  <span>
                                      <span>We collect the above mentioned categories of personal information, either directly or indirectly, from you when you use this Website.</span>
                                  </span>
                              </span>
                          </span>
                      </span>
                  </span>
              </p>
              <p>
                  <span>
                      <span>
                          <span>
                              <span>
                                  <span>
                                      <span>For example, you directly provide your personal information when you submit requests via any forms on this Website. You also provide personal information indirectly when you navigate this Website, as personal information about you is automatically observed and collected. Finally, we may collect your personal information from third parties that work with us in connection with the Service or with the functioning of this Website and features thereof.</span>
                                  </span>
                              </span>
                          </span>
                      </span>
                  </span>
              </p>
              <p>
                  <span>
                      <span>
                          <span>
                              <span>
                                  <span>
                                      <span>
                                          <span>How we use the information we collect: sharing and disclosing of your personal information with third parties for a business purpose</span>
                                      </span>
                                  </span>
                              </span>
                          </span>
                      </span>
                  </span>
              </p>
              <p>
                  <span>
                      <span>
                          <span>
                              <span>
                                  <span>
                                      <span>We may disclose the personal information we collect about you to a third party for business purposes. In this case, we enter a written agreement with such third party that requires the recipient to both keep the personal information confidential and not use it for any purpose(s) other than those necessary for the performance of the agreement.</span>
                                  </span>
                              </span>
                          </span>
                      </span>
                  </span>
              </p>
              <p>
                  <span>
                      <span>
                          <span>
                              <span>
                                  <span>
                                      <span>We may also disclose your personal information to third parties when you explicitly ask or authorize us to do so, in order to provide you with our Service.</span>
                                  </span>
                              </span>
                          </span>
                      </span>
                  </span>
              </p>
              <p>
                  <span>
                      <span>
                          <span>
                              <span>
                                  <span>
                                      <span>To find out more about the purposes of processing, please refer to the relevant section of this document.</span>
                                  </span>
                              </span>
                          </span>
                      </span>
                  </span>
              </p>
              <p>
                  <span>
                      <span>
                          <span>
                              <span>
                                  <span>
                                      <span>
                                          <span>Sale of your personal information</span>
                                      </span>
                                  </span>
                              </span>
                          </span>
                      </span>
                  </span>
              </p>
              <p>
                  <span>
                      <span>
                          <span>
                              <span>
                                  <span>
                                      <span>
                                          For our purposes, the word “sale” means any “selling, renting, releasing, disclosing, disseminating, making available, transferring or otherwise communicating orally, in writing, or by electronic means, a consumer's personal information by the business to&nbsp;
                                          <strong>another business or a third party, for monetary or other valuable consideration&nbsp;</strong>
                                          ”.
                                      </span>
                                  </span>
                              </span>
                          </span>
                      </span>
                  </span>
              </p>
              <p>
                  <span>
                      <span>
                          <span>
                              <span>
                                  <span>
                                      <span>This means that, for example, a sale can happen whenever an application runs ads, or makes statistical analyses on the traffic or views, or simply because it uses tools such as social network plugins and the like.</span>
                                  </span>
                              </span>
                          </span>
                      </span>
                  </span>
              </p>
              <p>
                  <span>
                      <span>
                          <span>
                              <span>
                                  <span>
                                      <span>
                                          <span>Your right to opt out of the sale of personal information</span>
                                      </span>
                                  </span>
                              </span>
                          </span>
                      </span>
                  </span>
              </p>
              <p>
                  <span>
                      <span>
                          <span>
                              <span>
                                  <span>
                                      <span>
                                          You have the right to opt out of the sale of your personal information. This means that whenever you request us to stop selling your data, we will abide by your request.<br />
                                          Such requests can be made freely, at any time, without submitting any verifiable request, simply by following the instructions below.
                                      </span>
                                  </span>
                              </span>
                          </span>
                      </span>
                  </span>
              </p>
              <p>
                  <span>
                      <span>
                          <span>
                              <span>
                                  <span>
                                      <span>
                                          <span>Instructions to opt out of the sale of personal information</span>
                                      </span>
                                  </span>
                              </span>
                          </span>
                      </span>
                  </span>
              </p>
              <p>
                  <span>
                      <span>
                          <span>
                              <span>
                                  <span>
                                      <span>If you’d like to know more, or exercise your right to opt out in regard to all the sales carried out by this Website, both online and offline, you can contact us for further information using the contact details provided in this document.</span>
                                  </span>
                              </span>
                          </span>
                      </span>
                  </span>
              </p>
              <p>
                  <span>
                      <span>
                          <span>
                              <span>
                                  <span>
                                      <span>
                                          <span>What are the purposes for which we use your personal information?</span>
                                      </span>
                                  </span>
                              </span>
                          </span>
                      </span>
                  </span>
              </p>
              <p>
                  <span>
                      <span>
                          <span>
                              <span>
                                  <span>
                                      <span>We may use your personal information to allow the operational functioning of this Website and features thereof (“business purposes”). In such cases, your personal information will be processed in a fashion necessary and proportionate to the business purpose for which it was collected, and strictly within the limits of compatible operational purposes.</span>
                                  </span>
                              </span>
                          </span>
                      </span>
                  </span>
              </p>
              <p>
                  <span>
                      <span>
                          <span>
                              <span>
                                  <span>
                                      <span>We may also use your personal information for other reasons such as for commercial purposes (as indicated within the section “Detailed information on the processing of Personal Data” within this document), as well as for complying with the law and defending our rights before the competent authorities where our rights and interests are threatened or we suffer an actual damage.</span>
                                  </span>
                              </span>
                          </span>
                      </span>
                  </span>
              </p>
              <p>
                  <span>
                      <span>
                          <span>
                              <span>
                                  <span>
                                      <span>We will not use your personal information for different, unrelated, or incompatible purposes without notifying you.</span>
                                  </span>
                              </span>
                          </span>
                      </span>
                  </span>
              </p>
              <p>
                  <span>
                      <span>
                          <span>
                              <span>
                                  <span>
                                      <span>
                                          <span>Your California privacy rights and how to exercise them</span>
                                      </span>
                                  </span>
                              </span>
                          </span>
                      </span>
                  </span>
              </p>
              <p>
                  <span>
                      <span>
                          <span>
                              <span>
                                  <span>
                                      <span>
                                          <span>The right to know and to portability</span>
                                      </span>
                                  </span>
                              </span>
                          </span>
                      </span>
                  </span>
              </p>
              <p>
                  <span>
                      <span>
                          <span>
                              <span>
                                  <span>
                                      <span>You have the right to request that we disclose to you:</span>
                                  </span>
                              </span>
                          </span>
                      </span>
                  </span>
              </p>
              <ul>
                  <li>
                      <span>
                          <span>
                              <span>
                                  <span>
                                      <span>
                                          <span>
                                              <span>the categories and sources of the personal information that we collect about you, the purposes for which we use your information and with whom such information is shared;</span>
                                          </span>
                                      </span>
                                  </span>
                              </span>
                          </span>
                      </span>
                  </li>
                  <li>
                      <span>
                          <span>
                              <span>
                                  <span>
                                      <span>
                                          <span>
                                              <span>in case of sale of personal information or disclosure for a business purpose, two separate lists where we disclose:</span>
                                          </span>
                                      </span>
                                  </span>
                              </span>
                          </span>
                      </span>
                  </li>
                  <li>
                      <span>
                          <span>
                              <span>
                                  <span>
                                      <span>
                                          <span>
                                              <span>for sales, the personal information categories purchased by each category of recipient; and</span>
                                          </span>
                                      </span>
                                  </span>
                              </span>
                          </span>
                      </span>
                  </li>
                  <li>
                      <span>
                          <span>
                              <span>
                                  <span>
                                      <span>
                                          <span>
                                              <span>for disclosures for a business purpose, the personal information categories obtained by each category of recipient.</span>
                                          </span>
                                      </span>
                                  </span>
                              </span>
                          </span>
                      </span>
                  </li>
              </ul>
              <p>
                  <span>
                      <span>
                          <span>
                              <span>
                                  <span>
                                      <span>The disclosure described above will be limited to the personal information collected or used over the past 12 months.</span>
                                  </span>
                              </span>
                          </span>
                      </span>
                  </span>
              </p>
              <p>
                  <span>
                      <span>
                          <span>
                              <span>
                                  <span>
                                      <span>If we deliver our response electronically, the information enclosed will be "portable", i.e. delivered in an easily usable format to enable you to transmit the information to another entity without hindrance – provided that this is technically feasible.</span>
                                  </span>
                              </span>
                          </span>
                      </span>
                  </span>
              </p>
              <p>
                  <span>
                      <span>
                          <span>
                              <span>
                                  <span>
                                      <span>
                                          <span>The right to request the deletion of your personal information</span>
                                      </span>
                                  </span>
                              </span>
                          </span>
                      </span>
                  </span>
              </p>
              <p>
                  <span>
                      <span>
                          <span>
                              <span>
                                  <span>
                                      <span>You have the right to request that we delete any of your personal information, subject to exceptions set forth by the law (such as, including but not limited to, where the information is used to identify and repair errors on this Website, to detect security incidents and protect against fraudulent or illegal activities, to exercise certain rights etc.).</span>
                                  </span>
                              </span>
                          </span>
                      </span>
                  </span>
              </p>
              <p>
                  <span>
                      <span>
                          <span>
                              <span>
                                  <span>
                                      <span>If no legal exception applies, as a result of exercising your right, we will delete your personal information and direct any of our service providers to do so.</span>
                                  </span>
                              </span>
                          </span>
                      </span>
                  </span>
              </p>
              <p>
                  <span>
                      <span>
                          <span>
                              <span>
                                  <span>
                                      <span>
                                          <span>How to exercise your rights</span>
                                      </span>
                                  </span>
                              </span>
                          </span>
                      </span>
                  </span>
              </p>
              <p>
                  <span>
                      <span>
                          <span>
                              <span>
                                  <span>
                                      <span>To exercise the rights described above, you need to submit your verifiable request to us by contacting us via the details provided in this document.</span>
                                  </span>
                              </span>
                          </span>
                      </span>
                  </span>
              </p>
              <p>
                  <span>
                      <span>
                          <span>
                              <span>
                                  <span>
                                      <span>For us to respond to your request, it’s necessary that we know who you are. Therefore, you can only exercise the above rights by making a verifiable request which must:</span>
                                  </span>
                              </span>
                          </span>
                      </span>
                  </span>
              </p>
              <ul>
                  <li>
                      <span>
                          <span>
                              <span>
                                  <span>
                                      <span>
                                          <span>
                                              <span>provide sufficient information that allows us to reasonably verify you are the person about whom we collected personal information or an authorized representative;</span>
                                          </span>
                                      </span>
                                  </span>
                              </span>
                          </span>
                      </span>
                  </li>
                  <li>
                      <span>
                          <span>
                              <span>
                                  <span>
                                      <span>
                                          <span>
                                              <span>describe your request with sufficient detail that allows us to properly understand, evaluate, and respond to it.</span>
                                          </span>
                                      </span>
                                  </span>
                              </span>
                          </span>
                      </span>
                  </li>
              </ul>
              <p>
                  <span>
                      <span>
                          <span>
                              <span>
                                  <span>
                                      <span>We will not respond to any request if we are unable to verify your identity and therefore confirm the personal information in our possession actually relates to you.</span>
                                  </span>
                              </span>
                          </span>
                      </span>
                  </span>
              </p>
              <p>
                  <span>
                      <span>
                          <span>
                              <span>
                                  <span>
                                      <span>If you cannot personally submit a verifiable request, you can authorize a person registered with the California Secretary of State to act on your behalf.</span>
                                  </span>
                              </span>
                          </span>
                      </span>
                  </span>
              </p>
              <p>
                  <span>
                      <span>
                          <span>
                              <span>
                                  <span>
                                      <span>If you are an adult, you can make a verifiable request on behalf of a minor under your parental authority.</span>
                                  </span>
                              </span>
                          </span>
                      </span>
                  </span>
              </p>
              <p>
                  <span>
                      <span>
                          <span>
                              <span>
                                  <span>
                                      <span>You can submit a maximum number of 2 requests over a period of 12 months.</span>
                                  </span>
                              </span>
                          </span>
                      </span>
                  </span>
              </p>
              <p>
                  <span>
                      <span>
                          <span>
                              <span>
                                  <span>
                                      <span>
                                          <span>How and when we are expected to handle your request</span>
                                      </span>
                                  </span>
                              </span>
                          </span>
                      </span>
                  </span>
              </p>
              <p>
                  <span>
                      <span>
                          <span>
                              <span>
                                  <span>
                                      <span>We will confirm receipt of your verifiable request within 10 days and provide information about how we will process your request.</span>
                                  </span>
                              </span>
                          </span>
                      </span>
                  </span>
              </p>
              <p>
                  <span>
                      <span>
                          <span>
                              <span>
                                  <span>
                                      <span>We will respond to your request within 45 days of its receipt. Should we need more time, we will explain to you the reasons why, and how much more time we need. In this regard, please note that we may take up to 90 days to fulfill your request.</span>
                                  </span>
                              </span>
                          </span>
                      </span>
                  </span>
              </p>
              <p>
                  <span>
                      <span>
                          <span>
                              <span>
                                  <span>
                                      <span>Our disclosure(s) will cover the preceding 12 month period.</span>
                                  </span>
                              </span>
                          </span>
                      </span>
                  </span>
              </p>
              <p>
                  <span>
                      <span>
                          <span>
                              <span>
                                  <span>
                                      <span>Should we deny your request, we will explain you the reasons behind our denial.</span>
                                  </span>
                              </span>
                          </span>
                      </span>
                  </span>
              </p>
              <p>
                  <span>
                      <span>
                          <span>
                              <span>
                                  <span>
                                      <span>We do not charge a fee to process or respond to your verifiable request unless such request is manifestly unfounded or excessive. In such cases, we may charge a reasonable fee, or refuse to act on the request. In either case, we will communicate our choices and explain the reasons behind it.</span>
                                  </span>
                              </span>
                          </span>
                      </span>
                  </span>
              </p>
              <p>
                  <span>
                      <span>
                          <span>
                              <span>
                                  <span>
                                      <span>
                                          <span>Definitions and legal references</span>
                                      </span>
                                  </span>
                              </span>
                          </span>
                      </span>
                  </span>
              </p>
              <p>
                  <span>
                      <span>
                          <span>
                              <span>
                                  <span>
                                      <span>
                                          <span>Personal Data (or Data)</span>
                                      </span>
                                  </span>
                              </span>
                          </span>
                      </span>
                  </span>
              </p>
              <p>
                  <span>
                      <span>
                          <span>
                              <span>
                                  <span>
                                      <span>Any information that directly, indirectly, or in connection with other information — including a personal identification number — allows for the identification or identifiability of a natural person.</span>
                                  </span>
                              </span>
                          </span>
                      </span>
                  </span>
              </p>
              <p>
                  <span>
                      <span>
                          <span>
                              <span>
                                  <span>
                                      <span>
                                          <span>Usage Data</span>
                                      </span>
                                  </span>
                              </span>
                          </span>
                      </span>
                  </span>
              </p>
              <p>
                  <span>
                      <span>
                          <span>
                              <span>
                                  <span>
                                      <span>Information collected automatically through this Website (or third-party services employed in this Website), which can include: the IP addresses or domain names of the computers utilized by the Users who use this Website, the URI addresses (Uniform Resource Identifier), the time of the request, the method utilized to submit the request to the server, the size of the file received in response, the numerical code indicating the status of the server's answer (successful outcome, error, etc.), the country of origin, the features of the browser and the operating system utilized by the User, the various time details per visit (e.g., the time spent on each page within the Application) and the details about the path followed within the Application with special reference to the sequence of pages visited, and other parameters about the device operating system and/or the User's IT environment.</span>
                                  </span>
                              </span>
                          </span>
                      </span>
                  </span>
              </p>
              <p>
                  <span>
                      <span>
                          <span>
                              <span>
                                  <span>
                                      <span>
                                          <span>User</span>
                                      </span>
                                  </span>
                              </span>
                          </span>
                      </span>
                  </span>
              </p>
              <p>
                  <span>
                      <span>
                          <span>
                              <span>
                                  <span>
                                      <span>The individual using this Website who, unless otherwise specified, coincides with the Data Subject.</span>
                                  </span>
                              </span>
                          </span>
                      </span>
                  </span>
              </p>
              <p>
                  <span>
                      <span>
                          <span>
                              <span>
                                  <span>
                                      <span>
                                          <span>Data Subject</span>
                                      </span>
                                  </span>
                              </span>
                          </span>
                      </span>
                  </span>
              </p>
              <p>
                  <span>
                      <span>
                          <span>
                              <span>
                                  <span>
                                      <span>The natural person to whom the Personal Data refers.</span>
                                  </span>
                              </span>
                          </span>
                      </span>
                  </span>
              </p>
              <p>
                  <span>
                      <span>
                          <span>
                              <span>
                                  <span>
                                      <span>
                                          <span>Data Processor (or Data Supervisor)</span>
                                      </span>
                                  </span>
                              </span>
                          </span>
                      </span>
                  </span>
              </p>
              <p>
                  <span>
                      <span>
                          <span>
                              <span>
                                  <span>
                                      <span>The natural or legal person, public authority, agency or other body which processes Personal Data on behalf of the Controller, as described in this privacy policy.</span>
                                  </span>
                              </span>
                          </span>
                      </span>
                  </span>
              </p>
              <p>
                  <span>
                      <span>
                          <span>
                              <span>
                                  <span>
                                      <span>
                                          <span>Data Controller (or Owner)</span>
                                      </span>
                                  </span>
                              </span>
                          </span>
                      </span>
                  </span>
              </p>
              <p>
                  <span>
                      <span>
                          <span>
                              <span>
                                  <span>
                                      <span>The natural or legal person, public authority, agency or other body which, alone or jointly with others, determines the purposes and means of the processing of Personal Data, including the security measures concerning the operation and use of this Website. The Data Controller, unless otherwise specified, is the Owner of this Website.</span>
                                  </span>
                              </span>
                          </span>
                      </span>
                  </span>
              </p>
              <p>
                  <span>
                      <span>
                          <span>
                              <span>
                                  <span>
                                      <span>
                                          <span>This Website (or this Application)</span>
                                      </span>
                                  </span>
                              </span>
                          </span>
                      </span>
                  </span>
              </p>
              <p>
                  <span>
                      <span>
                          <span>
                              <span>
                                  <span>
                                      <span>The means by which the Personal Data of the User is collected and processed.</span>
                                  </span>
                              </span>
                          </span>
                      </span>
                  </span>
              </p>
              <p>
                  <span>
                      <span>
                          <span>
                              <span>
                                  <span>
                                      <span>
                                          <span>Service</span>
                                      </span>
                                  </span>
                              </span>
                          </span>
                      </span>
                  </span>
              </p>
              <p>
                  <span>
                      <span>
                          <span>
                              <span>
                                  <span>
                                      <span>The service provided by this Website as described in the relative terms (if available) and on this site/application.</span>
                                  </span>
                              </span>
                          </span>
                      </span>
                  </span>
              </p>
              <p>
                  <span>
                      <span>
                          <span>
                              <span>
                                  <span>
                                      <span>
                                          <span>European Union (or EU)</span>
                                      </span>
                                  </span>
                              </span>
                          </span>
                      </span>
                  </span>
              </p>
              <p>
                  <span>
                      <span>
                          <span>
                              <span>
                                  <span>
                                      <span>Unless otherwise specified, all references made within this document to the European Union include all current member states to the European Union and the European Economic Area.</span>
                                  </span>
                              </span>
                          </span>
                      </span>
                  </span>
              </p>
              <p>
                  <span>
                      <span>
                          <span>
                              <span>
                                  <span>
                                      <span>
                                          <span>Cookie</span>
                                      </span>
                                  </span>
                              </span>
                          </span>
                      </span>
                  </span>
              </p>
              <p>
                  <span>
                      <span>
                          <span>
                              <span>
                                  <span>
                                      <span>Cookies are Trackers consisting of small sets of data stored in the User's browser.</span>
                                  </span>
                              </span>
                          </span>
                      </span>
                  </span>
              </p>
              <p>
                  <span>
                      <span>
                          <span>
                              <span>
                                  <span>
                                      <span>
                                          <span>Tracker</span>
                                      </span>
                                  </span>
                              </span>
                          </span>
                      </span>
                  </span>
              </p>
              <p>
                  <span>
                      <span>
                          <span>
                              <span>
                                  <span>
                                      <span>Tracker indicates any technology - e.g Cookies, unique identifiers, web beacons, embedded scripts, e-tags and fingerprinting - that enables the tracking of Users, for example by accessing or storing information on the User’s device.</span>
                                  </span>
                              </span>
                          </span>
                      </span>
                  </span>
              </p>
              <p>
                  <span>
                      <span>
                          <span>
                              <span>
                                  <span>
                                      <span>
                                          <span>Legal information</span>
                                      </span>
                                  </span>
                              </span>
                          </span>
                      </span>
                  </span>
              </p>
              <p>
                  <span>
                      <span>
                          <span>
                              <span>
                                  <span>
                                      <span>This privacy statement has been prepared based on provisions of multiple legislations, including Art. 13/14 of Regulation (EU) 2016/679 (General Data Protection Regulation).</span>
                                  </span>
                              </span>
                          </span>
                      </span>
                  </span>
              </p>
              <p>
                  <span>
                      <span>
                          <span>
                              <span>
                                  <span>
                                      <span>This privacy policy relates solely to this Website, if not stated otherwise within this document.</span>
                                  </span>
                              </span>
                          </span>
                      </span>
                  </span>
              </p>
              <p>
                  <span>
                      <span>
                          <span>
                              <span>
                                  <span>
                                      <span>
                                          <span>Latest update: July 04, 2022</span>
                                      </span>
                                  </span>
                              </span>
                          </span>
                      </span>
                  </span>
              </p>
          </div>
      </section>
        </div>
      </section>
      <Footer />
    </div>
  );
}
